module.exports = __webpack_public_path__ + "static/media/sx.73a3a178.svg";